/**
 * "Install the TDIA GitHub App" (DEC-200, UI_SDD §R.15). Shown beside the OAuth connect,
 * only when the server has the App configured; otherwise it renders nothing.
 */
import { useQuery } from '@tanstack/react-query'
import { githubAppApi } from '../../api/githubApp'

export function InstallGitHubApp({ className = '' }: { className?: string }) {
  const { data } = useQuery({
    queryKey: ['github-app'],
    queryFn: githubAppApi.info,
    staleTime: 5 * 60_000,
    retry: false,
  })
  if (!data?.configured || !data.install_url) return null
  return (
    <div className={className} data-testid="install-github-app">
      <a
        href={data.install_url}
        className="inline-flex items-center rounded-md border border-hairline-strong px-3 py-[6px] text-[12px] font-semibold text-body hover:bg-hover-hue focus:outline-none focus-visible:shadow-focus"
      >
        Install the TDIA GitHub App
      </a>
      <p className="text-[11px] text-muted mt-1 m-0">
        The App scans on every push and posts results on pull requests. Connect GitHub lets you pick a
        repository and scan it now.
      </p>
    </div>
  )
}
